import script from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=391ad3d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391ad3d8"]])

export default __exports__